import { render, staticRenderFns } from "./RequestDetailsNew.vue?vue&type=template&id=a532664a&scoped=true"
import script from "./RequestDetailsNew.vue?vue&type=script&lang=ts"
export * from "./RequestDetailsNew.vue?vue&type=script&lang=ts"
import style0 from "./RequestDetailsNew.vue?vue&type=style&index=0&id=a532664a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a532664a",
  null
  
)

export default component.exports